// Bridges React Router's getUserConfirmation callback (which fires when a
// <Prompt> is active and the user tries to navigate) to whichever React
// component has registered itself as the current confirm handler.
//
// Usage:
//   routes.js passes getUserConfirmation to <BrowserRouter> that calls
//   navigationConfirmService.trigger(callback).
//
//   UnsavedChangesGuard registers itself on mount and unregisters on unmount.
//   When triggered it shows its own styled dialog; the user's choice resolves
//   the callback (true = allow navigation, false = block it).

let _triggerFn = null;

const navigationConfirmService = {
  register(fn) {
    _triggerFn = fn;
  },
  unregister() {
    _triggerFn = null;
  },
  trigger(callback) {
    if (_triggerFn) {
      _triggerFn(callback);
    } else {
      // Fallback: no dialog mounted yet, use native confirm.
      callback(window.confirm('You have unsaved changes. Leave anyway?'));
    }
  }
};

export default navigationConfirmService;
